export default __webpack_public_path__ + "static/media/gallery (3).cb01902e.png";